import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MarkdownContentProps {
  children?: string | null
}

export function MarkdownContent({ children }: MarkdownContentProps) {
  if (!children) return null

  return (
    <div className="prose prose-sm dark:prose-invert max-w-none text-muted-foreground">
      <Markdown remarkPlugins={[remarkGfm]}>{children}</Markdown>
    </div>
  )
}
